import { render, staticRenderFns } from "./NewFixedColumn.vue?vue&type=template&id=67db6aae&"
import script from "./NewFixedColumn.vue?vue&type=script&lang=js&"
export * from "./NewFixedColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports